export const serviceProviderResourceUtilizationAreaPathName = 'ressourceforbrug';
